import stylesheet_3 from '../stylesheets/3.js';
import stylesheet_8 from '../stylesheets/8.js';
import stylesheet_7 from '../stylesheets/7.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/flight-instructor/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/7.96f316d5.js","_app/immutable/chunks/scheduler.2cb4bb00.js","_app/immutable/chunks/index.7d06ba6e.js","_app/immutable/chunks/ServicePageTemplate.5584832c.js","_app/immutable/chunks/each.b817d3ea.js","_app/immutable/chunks/Button.e2d11f27.js","_app/immutable/chunks/FinancingCard.ad541c10.js","_app/immutable/chunks/AirplaneTakeoff.7b04918d.js","_app/immutable/chunks/School.bcca1126.js","_app/immutable/chunks/CopyCard.145c53e7.js"];
export const stylesheets = ["_app/immutable/assets/7.62e84238.css","_app/immutable/assets/ServicePageTemplate.74e928c3.css","_app/immutable/assets/Button.9f808f14.css","_app/immutable/assets/FinancingCard.191c1fad.css","_app/immutable/assets/CopyCard.dab0def0.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/7.62e84238.css": stylesheet_3,
	"_app/immutable/assets/Button.9f808f14.css": stylesheet_8,
	"_app/immutable/assets/CopyCard.dab0def0.css": stylesheet_7
});
